<template>
  <div class="steps">
    <el-steps :active="active">
      <el-step v-for="(step,index) in options" :key="'step'+index" :title="step.title" :description="step.desc + '   ' + (step.name ? step.name : '')"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'v-steps',
  props: ['params', 'rowData'],
  computed: {
    options() {
      return this.rowData.options
    },
    active() {
      return this.rowData.active
    }
  }
}
</script>

<style lang="less">
@import "../../../styles/index.less";
</style>
